import { makeStyles } from "@mui/styles";
import BaseColor from "../../../Config/Color";
import { FontFamily } from "../../../Config/theme";

const styles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,

    "& .MuiGrid-container": {
      padding: "0 20px",
    },
  },
  paper: {
    padding: theme.spacing(3),
    margin: theme.spacing(3),
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  title: {
    marginBottom: theme.spacing(3),
    fontFamily: FontFamily.SemiBold,
    color: BaseColor.primary,
  },
  formSection: {
    padding: theme.spacing(3),
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    transition: "box-shadow 0.3s ease",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    },
  },
  sectionTitle: {
    fontFamily: FontFamily.SemiBold,
    color: BaseColor.primary,
  },

  labelText: {
    color: BaseColor.textSecondary,
    fontSize: "0.875rem",
    marginBottom: "4px",
    fontFamily: FontFamily.Medium,
    fontWeight: "bold",
  },
  valueText: {
    color: BaseColor.textPrimary,
    fontSize: "1rem",
    fontFamily: FontFamily.Regular,
  },
  tabPanel: {
    padding: theme.spacing(3),
  },
  formControl: {
    minWidth: 120,
    margin: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  reviewCard: {
    padding: "20px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    marginBottom: "20px",
    "&:hover": {
      boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
      transition: "box-shadow 0.3s ease-in-out",
    },
  },
  starRating: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    marginBottom: "10px",
  },
  postCard: {
    padding: "20px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    marginBottom: "20px",
    "&:hover": {
      boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
      transition: "box-shadow 0.3s ease-in-out",
    },
  },
  statusChip: {
    "&.MuiChip-root": {
      backgroundColor: BaseColor.primary,
      color: "#fff",
      "&.MuiChip-colorDefault": {
        backgroundColor: "#e0e0e0",
        color: "#666",
      },
    },
  },
  imageThumbnail: {
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "8px",
    cursor: "pointer",
    border: `2px solid transparent`,
    "&:hover": {
      border: `2px solid ${BaseColor.primary}`,
    },
  },
  mainImage: {
    width: "100%",
    height: "300px",
    objectFit: "contain",
    borderRadius: "8px",
    marginBottom: theme.spacing(2),
  },
  thumbnailsContainer: {
    display: "flex",
    overflowX: "auto",
    gap: "8px",
    padding: "8px 0",
    "&::-webkit-scrollbar": {
      height: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: BaseColor.primary,
      borderRadius: "6px",
    },
  },
  headerCard: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  actionButtons: {
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      marginTop: theme.spacing(2),
    },
  },
  backButton: {
    marginBottom: theme.spacing(3),
  },
  infoIcon: {
    color: BaseColor.primary,
    marginRight: theme.spacing(1),
    verticalAlign: "middle",
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "8px",
  },
}));

export default styles;
